// Le dictionnaire italien de l'interface (issue #137), dans son propre fichier
// pour ne pas alourdir `i18n.ts`.
//
// TRADUCTION AUTOMATIQUE, PAS ENCORE RELUE. La langue reste hors de
// `LANGUES_OUVERTES` (`lang.ts`) tant que quelqu'un qui la parle ne l'a pas
// relue : servie à qui la demande (`?lang=it`), jamais proposée.
//
// Typé `Record<CleUi, string>` : une clé ajoutée au français sans sa
// traduction ici fait échouer la compilation. Interface au tutoiement (« tu ») : la norme des
// interfaces en italien, quand le français et le néerlandais vouvoient.

import type { CleUi } from './i18n'

export const DICT_IT: Record<CleUi, string> = {
  'acces.fin.titre': 'Il tuo accesso a Radar è terminato.',
  'acces.essai.fin': 'La tua prova gratuita termina il {date}.',
  'acces.essai.choisir': 'Scegli un piano',
  'acces.fin.texte': 'Le tue offerte, le tue candidature e il tuo CV restano consultabili. L’osservazione notturna e i nuovi dossier riprenderanno con un abbonamento.',
  'autreCompte.texte': 'Questo link viene dall’e-mail di un altro account.',
  'autreCompte.changer': 'Cambia account',
  'autreCompte.rester': 'Resta qui',
  'abonnement.titre': 'Abbonamento',
  'abonnement.sAbonner': 'Abbonati',
  'abonnement.redirection': 'Reindirizzamento al pagamento…',
  'abonnement.parMois': 'al mese',
  'abonnement.parAn': 'all’anno',
  'abonnement.ttc': 'IVA inclusa',
  'abonnement.offert': 'Radar ti è offerto.',
  'compteurs.titre': 'Il tuo utilizzo',
  'compteurs.cv': 'CV adattati questa settimana',
  'compteurs.employeurs': 'Datori di lavoro seguiti',
  'compteurs.recherches': 'Stipendio e colloquio questo mese',
  'compteurs.sur': 'su {max}',
  'compteurs.sansLimite': 'Senza limite',
  'compteurs.repart': 'Riparte il {date}',
  'compteurs.atteint': 'Raggiunto, riparte il {date}',
  'compteurs.plein': 'Limite raggiunto',
  'compteurs.avecComplet': 'Con Complet',
  'abonnement.essaiJusqua': 'Prova gratuita fino al {date}.',
  'abonnement.essaiFini': 'La tua prova gratuita è terminata il {date}.',
  'abonnement.duree': 'Durata',
  'abonnement.auMois': 'Mensile',
  'abonnement.alAnnee': 'Annuale',
  'abonnement.radar': 'Radar',
  'abonnement.complet': 'Complet',
  'abonnement.radar.l1': '20 datori di lavoro seguiti',
  'abonnement.radar.l2': '15 CV adattati a settimana',
  'abonnement.complet.l1': 'Tutti i datori di lavoro',
  'abonnement.complet.l2': 'CV adattati senza limite',
  'abonnement.complet.l3': 'Stipendio e colloquio a volontà',
  'abonnement.radar.l3': 'Stipendio e colloquio: 2 al mese',
  'abonnement.radar.l4': '4 modelli di CV',
  'abonnement.complet.l4': 'Il mio layout, ripreso dal tuo CV',
  'abonnement.choisir': 'Scegli {plan}',
  'abonnement.abonne': 'Sei abbonato.',
  'abonnement.abonneJusqua': 'Sei abbonato. Prossima scadenza: {date}.',
  'abonnement.finLe': 'Il tuo abbonamento termina il {date}.',
  'abonnement.gerer': 'Carta, fatture, disdetta',
  'abonnement.reprendre': 'Riprendi l’abbonamento',
  'abonnement.enRetard': 'L’ultimo pagamento non è riuscito. Controlla la tua carta.',
  'abonnement.mettreAJour': 'Aggiorna la mia carta',
  'abonnement.confirmation': 'Pagamento ricevuto, conferma in corso…',
  'abonnement.confirmationLongue': 'La conferma tarda. Stripe te la invierà per e-mail; ricarica questa pagina tra qualche minuto.',
  'abonnement.annule': 'Pagamento annullato. Non è cambiato nulla.',
  'abonnement.pasOuvert': 'Il pagamento non è ancora aperto.',
  'nav.config': 'Configurazione',
  'lang.toggle.label': 'Lingua dell’interfaccia',
  'nav.mainAria': 'Navigazione principale',
  'nav.logout': 'Esci',
  'nav.accountFallbackRadar': 'Il mio account',
  'nav.accountFallbackConsole': 'Business Manager',
  'nav.consultantsCount': '{n} consulenti',
  'login.radar.accroche': 'Le offerte fatte per te, ogni mattina.',
  'login.modes': 'Accedi o crea un account',
  'login.ou': 'oppure',
  'login.mdp.voir': 'Mostra la password',
  'login.mdp.masquer': 'Nascondi la password',
  'inscription.titre': 'Crea un account',
  'inscription.mdp': 'Scegli una password',
  'inscription.mdpAide': 'Almeno {n} caratteri.',
  'inscription.envoyer': 'Crea il mio account',
  'inscription.envoi': 'Invio…',
  'inscription.essai': 'Un mese gratis, senza carta.',
  'inscription.robot': 'Spunta la verifica anti-robot.',
  'inscription.parti.texte': 'Abbiamo appena inviato un link a {email}. Aprilo per attivare il tuo account.',
  'inscription.autreAdresse': 'Usa un altro indirizzo',
  'inscription.activation': 'Attivazione del tuo account…',
  'inscription.lienInvalide': 'Questo link non è più valido. Ricomincia l’iscrizione.',
  'login.subtitle.console': 'Console di consulenza',
  'login.subtitle.admin': 'Amministrazione',
  'login.subtitle.radar': 'Radar',
  'login.email': 'Indirizzo e-mail',
  'login.password': 'Password',
  'login.submitting': 'Accesso…',
  'login.submit': 'Accedi',
  'login.error.generic': 'Accesso impossibile.',
  'login.oubli.lien': 'Password dimenticata?',
  'login.google.bouton': 'Continua con Google',
  'login.google.sans_compte': 'Nessun account per questo indirizzo Google. L’accesso è su invito.',
  'login.google.expire': 'L’accesso con Google è scaduto. Riprova.',
  'login.google.annule': 'Accesso con Google annullato.',
  'login.google.erreur': 'Google non ha potuto confermare la tua identità. Riprova.',
  'login.google.ferme': 'Le iscrizioni sono chiuse per il momento.',
  'login.google.inscription': 'Non hai ancora un account? Lo crea Google. Un mese gratis, senza carta.',
  'login.google.refuse': 'Impossibile creare un account con questo indirizzo Google.',
  'login.oubli.titre': 'Il tuo indirizzo',
  'login.oubli.envoyer': 'Ricevi un link di accesso',
  'login.oubli.parti': 'Se esiste un account con questo indirizzo, è appena partito un link. Vale 30 minuti.',
  'accueil.step': 'Passo {n} di {total}',
  'accueil.next': 'Avanti',
  'accueil.back': 'Indietro',
  'accueil.finish': 'Fine',
  'accueil.done': 'Benvenuto. Trovi tutto in “Per iniziare” se vuoi rileggere.',
  'accueil.radar.title': 'Radar cerca mentre fai altro',
  'accueil.radar.lead': 'Siti riletti ogni notte, al posto tuo.',
  'accueil.radar.body': 'Scegli dei siti di offerte. Ogni notte Radar li rilegge, tiene ciò che è nuovo, confronta ogni annuncio con il tuo CV e gli dà un punteggio. Al mattino non cerchi: selezioni ciò che è emerso.',
  'accueil.radar.body2': 'Un’offerta che ti interessa si apre in una scheda: il punteggio dettagliato, cosa corrisponde, cosa manca, e tutto per generare un CV adattato e una lettera.',
  'accueil.radar.shot1Alt': 'Schermata “Le mie opportunità”: un elenco di offerte con il loro punteggio',
  'accueil.radar.shot2Alt': 'Scheda di un’offerta: punteggio dettagliato, punti di forza e lacune',
  'accueil.extension.title': 'L’estensione Chrome lavora dove sei tu',
  'accueil.extension.lead': 'Su LinkedIn, su Indeed, sul sito di un datore di lavoro: ovunque.',
  'accueil.extension.body': 'È facoltativa, ma è lei che ti accompagna sugli annunci: quando ne guardi uno, mostra il tuo punteggio, adatta il tuo CV a quell’offerta e scrive una lettera. Con un clic la invia anche a Radar, per tornarci più tardi.',
  'accueil.extension.videoNote': 'Due minuti, e vedrai esattamente com’è.',
  'accueil.ensemble.title': 'Due strumenti indipendenti, migliori insieme',
  'accueil.ensemble.lead': 'Uno cerca per te, l’altro ti segue quando cerchi tu.',
  'accueil.ensemble.passifTitle': 'Radar, la modalità che va da sola',
  'accueil.ensemble.passifBody': 'Rilegge i tuoi siti ogni notte e ti prepara una pila. Non devi fare nulla perché lavori.',
  'accueil.ensemble.actifTitle': 'L’estensione, la modalità del momento',
  'accueil.ensemble.actifBody': 'Agisce sull’annuncio che hai sotto gli occhi, anche su un sito che Radar non osserva.',
  'accueil.ensemble.body': 'Quando sono collegati, su ogni annuncio compare un pulsante: un clic, e l’offerta entra in Radar con il suo punteggio. L’offerta vista su LinkedIn a mezzogiorno è nel tuo storico la sera, e deciderai se rispondere quando avrai tempo.',
  'accueil.ensemble.independants': 'Puoi usarne anche uno solo. Nessuno dipende dall’altro.',
  'accueil.cv.title': 'Il tuo CV, una volta sola',
  'accueil.cv.lead': 'È il riferimento con cui si confronta tutto.',
  'accueil.cv.body': 'Caricalo in PDF. Viene letto e strutturato una sola volta, poi serve a dare un punteggio a ogni offerta e a produrre i CV adattati. Senza di lui niente può essere confrontato e le tue schermate resteranno vuote.',
  'accueil.cv.cta': 'Carica il mio CV',
  'accueil.cv.done': 'Il tuo CV è a posto.',
  'accueil.metiers.title': 'Le tue professioni',
  'accueil.metiers.lead': 'Ecco le professioni che abbiamo letto nel tuo CV.',
  'accueil.metiers.body': 'Radar valuta per te solo le offerte di queste professioni. Togli ciò che non ti somiglia, aggiungi ciò che manca: digita una professione e scegli dall’elenco.',
  'accueil.metiers.enCours': 'Lettura del tuo CV in corso, qualche secondo…',
  'accueil.metiers.needCv': 'Carica prima il tuo CV al passo precedente.',
  'accueil.metiers.later': 'Potrai cambiarle in qualsiasi momento sulla tua scheda profilo.',
  'accueil.sites.title': 'Scegli i tuoi siti',
  'accueil.sites.lead': 'Non c’è niente di spuntato: sei tu a dire cosa vuoi seguire.',
  'accueil.sites.body': 'Questi sono i siti che questo Radar sa già leggere. Spunta quelli che ti riguardano: vedrai solo le loro offerte, e non disturbi nessuno se cambi idea.',
  'accueil.sites.needCv': 'Carica il tuo CV al passo precedente per poter scegliere: i siti si collegano al tuo profilo.',
  'accueil.sites.offers': '{n} offerte',
  'accueil.sites.all': 'Spunta tutto',
  'accueil.sites.none': 'Togli tutto',
  'accueil.sites.count': '{n} siti scelti',
  'accueil.sites.countMax': '{n} / {max} siti scelti',
  'accueil.sites.plafond': 'Al massimo {max} siti: togline uno per sceglierne un altro.',
  'accueil.sites.later': 'Potrai aggiungerne, toglierne o chiederne di nuovi in qualsiasi momento in “Siti seguiti”.',
  'accueil.revoir': 'Rivedi la presentazione',
  'aide.intro': 'Cos’è Radar, come collegare l’estensione, e cosa non funzionerà al primo colpo. Questa pagina resta qui: tornaci quando vuoi.',
  'aide.what.title': 'Cosa fa Radar per te',
  'aide.what.body': 'Radar osserva pagine di offerte di lavoro, ogni notte, al posto tuo. Ogni offerta trovata viene confrontata con il tuo CV e riceve un punteggio. Non cerchi più: guardi ciò che è emerso, e decidi.',
  'aide.what.extension': 'L’estensione Chrome è l’altra metà: funziona su qualsiasi sito di offerte, mostra il tuo punteggio direttamente sull’annuncio, adatta il tuo CV e invia l’offerta a Radar con un clic. Un annuncio visto su LinkedIn a mezzogiorno si ritrova in Radar la sera, con il suo punteggio, senza che tu abbia annotato nulla.',
  'aide.step.cv.title': '1. Il tuo CV',
  'aide.step.cv.body': 'Tutto parte da lì: senza CV niente può essere confrontato. Caricalo in PDF, viene letto e strutturato una volta. Potrai sostituirlo in qualsiasi momento.',
  'aide.step.cv.cta': 'Carica o aggiorna il mio CV',
  'aide.step.install.title': '2. Installa l’estensione',
  'aide.step.install.body': 'Gratuita, sul Chrome Web Store. Un clic, niente da configurare.',
  'aide.step.install.store': 'Aggiungi a Chrome',
  'aide.step.install.storeS1': 'Sulla scheda, clicca “Aggiungi a Chrome”, poi “Aggiungi estensione”.',
  'aide.step.install.zipTitre': 'Installa senza il Chrome Web Store',
  'aide.step.install.zipQuand': 'Solo se lo store ti è bloccato, per esempio su un computer aziendale.',
  'aide.step.link.autrement': 'Nessun pulsante “Collega con Radar”? Accedi con il tuo indirizzo e la tua password Radar, o con il codice qui sotto.',
  'accueil2.extension.texte': 'Il tuo punteggio su ogni offerta, LinkedIn compreso: l’estensione è sul Chrome Web Store.',
  'accueil2.extension.plusTard': 'Più tardi',
  'aide.step.install.download': 'Scarica l’estensione (versione {version})',
  'aide.step.install.unavailable': 'Il pacchetto della versione {version} non è ancora pronto. Segnalalo in fondo a questa pagina, riceverai un messaggio appena sarà disponibile.',
  'aide.step.install.s1': 'Decomprimi il file scaricato in una cartella che terrai: Chrome leggerà l’estensione da lì, il cestino la disinstallerebbe.',
  'aide.step.install.s2': 'Apri chrome://extensions in una nuova scheda, poi attiva “Modalità sviluppatore” in alto a destra.',
  'aide.step.install.s3': 'Clicca “Carica estensione non pacchettizzata” e indica la cartella “ai-job-fit-{version}” che si trova DENTRO la cartella decompressa, non la cartella decompressa stessa. Se Chrome risponde “Manifest non trovato”, manca quel livello.',
  'aide.step.install.s4': 'Fissa l’icona alla barra degli strumenti: è da lì che attiverai l’estensione sui siti che non conosce ancora.',
  'aide.step.install.sites': 'Si attiva da sola su LinkedIn, Indeed e i grandi strumenti di selezione. Altrove Chrome chiede il tuo consenso sito per sito: apri l’annuncio, clicca l’icona dell’estensione, poi “Attiva su questo sito”. È una regola di Chrome, non un limite dello strumento.',
  'aide.step.link.title': '3. Collega l’estensione a Radar',
  'aide.step.link.body': 'Il tuo CV arriva allora da Radar: niente da importare nell’estensione, ed è qui che lo modifichi.',
  'aide.step.link.lastUsed': 'Estensione collegata. Ultimo invio: {date}.',
  'aide.step.link.neverUsed': 'Estensione collegata, ma nessuna offerta è ancora arrivata tramite lei.',
  'aide.step.link.s1': 'Apri l’estensione: al primo avvio si apre da sola. Altrimenti clic destro sulla sua icona, poi “Opzioni”.',
  'aide.step.link.s2': 'Sotto l’importazione del CV, clicca “Hai un account Radar? Accedi”, poi “Collega con Radar”. Chrome chiede l’accesso a Radar: accetta.',
  'aide.step.link.s3': 'Il tuo CV compare nell’estensione, e su ogni offerta compare un pulsante “Salva in Radar”.',
  'aide.step.sites.title': '4. Aggiungi un sito da osservare',
  'aide.step.sites.body': 'Incolla l’indirizzo di una pagina che ELENCA delle offerte, non di un singolo annuncio. Radar prova l’estrazione davanti a te e mostra i titoli trovati prima di salvare qualsiasi cosa.',
  'aide.step.sites.warning': 'Da sapere in anticipo: non funzionerà al primo colpo su tutti i siti. Radar riconosce da solo le grandi piattaforme; ogni altro sito richiede una riga di configurazione scritta a mano. In quel caso compare un pulsante “richiedi l’attivazione”: la richiesta viene registrata, ricevi un’e-mail di conferma, poi una seconda quando il sito è online, in genere entro una settimana. Non è un guasto, è il funzionamento normale.',
  'aide.step.sites.cta': 'Vai ai miei siti osservati',
  'aide.shared.title': 'Cosa è condiviso e cosa no',
  'aide.shared.body': 'I siti osservati e le offerte raccolte sono COMUNI agli account di questo Radar: vedi i siti aggiunti dagli altri, e loro vedono i tuoi. Il tuo CV, i tuoi punteggi, le tue candidature e i tuoi documenti invece sono visibili solo a te.',
  'aide.feedback.title': 'Una parola a chi sviluppa Radar',
  'aide.feedback.body': 'Qualcosa non funziona, una schermata è confusa, manca una funzione, un sito non è supportato: scrivilo qui. Il messaggio arriva direttamente per e-mail, con il tuo indirizzo perché la risposta ti torni.',
  'aide.feedback.typeLabel': 'Di cosa si tratta',
  'aide.feedback.type.bug': 'Qualcosa non funziona',
  'aide.feedback.type.idea': 'Un’idea, un miglioramento',
  'aide.feedback.type.site': 'Un sito da supportare',
  'aide.feedback.type.other': 'Altro',
  'aide.feedback.messageLabel': 'Il tuo messaggio',
  'aide.feedback.placeholder': 'Cosa stavi facendo, cosa ti aspettavi, cosa è successo invece.',
  'aide.feedback.send': 'Invia',
  'aide.feedback.sending': 'Invio…',
  'aide.feedback.sent': 'Messaggio inviato. Grazie, riceverai una risposta al tuo indirizzo.',
  'aide.feedback.stored': 'Messaggio registrato, ma l’e-mail non è partita. Verrà letto comunque.',
  'password.title': 'Scegli la tua password',
  'password.intro': 'Questo account è stato aperto con una password provvisoria. Devi sostituirla prima di andare avanti.',
  'password.current': 'Password provvisoria',
  'password.next': 'Nuova password',
  'password.confirm': 'Conferma',
  'password.rule': 'Almeno {n} caratteri. Nessun’altra regola: una frase che ricordi vale più di un insieme di simboli.',
  'password.submit': 'Salva e continua',
  'password.submitting': 'Salvataggio…',
  'password.tooShort': 'La nuova password deve avere almeno {n} caratteri.',
  'password.mismatch': 'Le due voci non corrispondono.',
  'password.error.generic': 'Modifica impossibile.',
  'password.error.same': 'La nuova password deve essere diversa da quella attuale.',
  'password.logout': 'Esci',
  'invite.title': 'Crea il tuo account',
  'invite.intro': 'Questo link apre un account {produit} all’indirizzo qui sotto. Scegli la tua password per iniziare.',
  'invite.email': 'Indirizzo dell’account',
  'invite.submit': 'Crea il mio account',
  'invite.submitting': 'Creazione…',
  'invite.loading': 'Verifica del link…',
  'invite.gone.title': 'Questo link non è più valido',
  'invite.gone.expiree': 'È scaduto. Chiedi un nuovo link a chi te l’ha inviato.',
  'invite.gone.utilisee': 'È già servito a creare un account. Accedi con l’indirizzo e la password scelti in quel momento.',
  'invite.gone.revoquee': 'È stato sostituito o annullato. Chiedi un nuovo link a chi te l’ha inviato.',
  'invite.gone.inconnue': 'Questo link è incompleto o errato. Controlla che sia stato copiato per intero.',
  'invite.gone.compte_existant': 'Esiste già un account con questo indirizzo. Accedi con la sua password.',
  'invite.otherProduct': 'Questo link apre un account su un altro sito.',
  'invite.otherProductOpen': 'Apri il sito giusto',
  'invite.toLogin': 'Vai all’accesso',
  'invite.error.generic': 'Creazione dell’account impossibile.',
  'candidature.stepToast': 'Fase: {label}',
  'candidature.propose': 'Proponi',
  'candidature.proposeName': 'Proponi {name}',
  'candidature.proposedToast': '{name} proposto, la candidatura è nel monitoraggio',
  'common.loading': 'Caricamento…',
  'common.close': 'Chiudi',
  'common.cancel': 'Annulla',
  'common.update': 'Aggiorna',
  'common.import': 'Importa',
  'importCv.updateTitle': 'Aggiorna {name}',
  'importCv.importing': 'Importazione…',
  'importCv.needFile': 'Scegli un file PDF',
  'importCv.updatedToast': 'Profilo di {name} aggiornato',
  'importCv.fileLabel': 'CV (PDF)',
  'importCv.depot': 'Trascina qui il PDF, o clicca per sceglierlo',
  'importCv.fileHelp': 'Estrazione del testo, strutturazione del profilo da parte dell’IA, poi vettorizzazione per il matching (~10 s). Il titolo del ruolo viene letto nel CV.',
  'importCv.nameLabel': 'Nome (facoltativo)',
  'importCv.namePlaceholder': 'Altrimenti: letto nel CV',
  'gapQuestions.title': 'Prima di generare, {n} dettagli',
  'gapQuestions.titleOne': 'Prima di generare, un dettaglio',
  'gapQuestions.skip': 'Salta',
  'gapQuestions.generating': 'Generazione…',
  'gapQuestions.introPlural': 'L’offerta chiede cose che il CV non dice esplicitamente. Rispondere o no non cambia il fatto che il CV venga adattato, solo ciò che potrà valorizzare.',
  'gapQuestions.introSingular': 'L’offerta chiede una cosa che il CV non dice esplicitamente. Rispondere o no non cambia il fatto che il CV venga adattato, solo ciò che potrà valorizzare.',
  'gapQuestions.placeholder': 'Un’esperienza da citare, anche breve? Altrimenti lascia vuoto.',
  'gapQuestions.answeredNone': 'Niente compilato per ora, l’adattamento partirà senza arricchimento.',
  'gapQuestions.answeredPlural': '{n} risposte verranno considerate.',
  'gapQuestions.answeredSingular': '1 risposta verrà considerata.',
  'gapQuestions.noneNeeded': 'Nessuna domanda: il CV copre già l’offerta.',
  'vivier.loading': 'Caricamento del vivaio…',
  'vivier.wentOnMission': '{name} in missione',
  'vivier.backOnBench': '{name} di nuovo disponibile',
  'vivier.archivedToast': '{name} archiviato, storico conservato',
  'vivier.reactivatedToast': '{name} riattivato',
  'vivier.summary': '{available} disponibili · {onMission} in missione · {archived} archiviati',
  'vivier.showActive': 'Vedi il vivaio attivo',
  'vivier.showArchived': 'Archiviati ({n})',
  'vivier.importCv': 'Importa un CV',
  'vivier.avgScore': 'Punt. medio',
  'vivier.evaluated': 'Valutato',
  'vivier.positioned': 'Proposto',
  'vivier.updated': 'Agg.',
  'vivier.reactivate': 'Riattiva',
  'vivier.onMission': 'In missione',
  'vivier.onBench': 'Disponibile',
  'vivier.archive': 'Archivia',
  'vivier.dropzoneTitle': 'Importa un CV in PDF',
  'vivier.dropzoneHint': 'Estrazione → profilo strutturato → vettorizzazione. Valutato sulle offerte future.',
  'vivier.noArchived': 'Nessun consulente archiviato.',
  'dossier.revert': '↩ ripristina',
  'dossier.defautEnregistre': 'Impostazioni salvate per i tuoi prossimi CV.',
  'modeles.sobre': 'Sobrio',
  'modeles.dates': 'Date a sinistra',
  'modeles.colonnes': 'Due colonne',
  'modeles.colonnes.note': 'Due colonne: alcuni software di selezione la leggono male.',
  'modeles.compact': 'Compatto',
  'modeles.perso': 'Il mio layout',
  'modeles.perso.complet': 'Con Completo',
  'modeles.perso.note': 'Ripreso dal tuo CV. Il Word resta con il layout standard.',
  'modeles.perso.enCours': 'In preparazione',
  'modeles.perso.aPreparer': 'Da preparare in Il mio CV',
  'modeles.parDefaut': 'Questo modello servirà per i tuoi prossimi CV.',
  'config.modeleLabel': 'Layout',
  'config.modele.sobreEffet': 'Una colonna, letta da tutti i software di selezione.',
  'config.modele.datesEffet': 'Le date in una colonna, a sinistra di ogni posto.',
  'config.modele.compactEffet': 'Più fitto, per stare in meno pagine.',
  'config.modele.persoEffet': 'Ripreso dal tuo CV, con Radar Completo.',
  'miseEnPage.titre': 'Il mio layout',
  'miseEnPage.texte': 'I tuoi CV adattati possono riprendere il layout del tuo CV.',
  'miseEnPage.prete': 'Pronto.',
  'miseEnPage.choix': 'Il modello dei tuoi prossimi CV, lo stesso delle Impostazioni.',
  'miseEnPage.enCours': 'In preparazione…',
  'miseEnPage.echec': 'Non è stato possibile ricavarlo dal tuo CV.',
  'miseEnPage.preparer': 'Prepara il mio layout',
  'miseEnPage.refaire': 'Rifai il mio layout',
  'miseEnPage.sansPdf': 'Carica il tuo CV in PDF per ricavarne il layout.',
  'miseEnPage.complet': 'Con Radar Completo.',
  'miseEnPage.formules': 'Vedi le formule',
  'miseEnPage.essai': 'La tua prova ne comprende uno.',
  'dossier.revertedToast': 'Frase ripristinata, audit ricalcolato',
  'dossier.loadingFile': 'Caricamento del documento…',
  'dossier.notFound': 'Documento non trovato',
  'dossier.regeneratingFile': 'Nuova versione in corso…',
  'dossier.generatedOn': 'Generato {date}',
  'dossier.ouvrirCv': 'Apri il CV',
  'dossier.savedToast': 'CV salvato, audit ricalcolato',
  'categories.loadError': 'Caricamento impossibile',
  'categories.title': 'Categorie',
  'categories.close': 'Chiudi',
  'categories.edit': 'Modifica',
  'categories.empty': 'Nessuna categoria. Finché non ce n’è una, questa scheda non viene associata a nessuna offerta.',
  'categories.originHuman': 'corretta',
  'categories.originAi': 'proposta',
  'categories.neighbours': 'Categorie vicine',
  'categories.neighboursHelp': 'I gruppi fratelli di quelli qui sopra. Non attivano una valutazione automatica, ma dicono chi sta proprio accanto.',
  'categories.selectedEmpty': 'Ancora nessuna professione. Digitane una qui sotto.',
  'categories.remove': 'Togli',
  'categories.searchLabel': 'Aggiungi una professione',
  'categories.searchPlaceholder': 'Digita una professione: sviluppatore, infermiera, contabile…',
  'categories.noResult': 'Nessuna professione trovata. Prova con un’altra parola.',
  'categories.saving': 'Salvataggio…',
  'categories.save': 'Salva',
  'categories.savedToast': 'Categorie salvate',
  'suivi.loading': 'Caricamento del monitoraggio…',
  'suivi.activeCountPlural': '{n} candidature in corso',
  'suivi.activeCountSingular': '{n} candidatura in corso',
  'suivi.setAsideAt': 'rimandata {when}',
  'suivi.putBackTitle': 'Rimetti in “{name}”',
  'suivi.putBackToast': '“{title}” rimessa in “{name}”',
  'suivi.closedSummary': '{placed} {placedLabel}, {refused} rifiutata/e',
  'suivi.offerGoneTitle': 'L’annuncio è sparito dal sito',
  'suivi.offerExpired': 'annuncio scaduto',
  'suivi.noMovementTitle': 'Nessun movimento da {n} giorni',
  'suivi.daysShort': '{n} g',
  'suivi.openFileTitle': 'Apri: {name}',
  'suivi.noFileTitle': 'Nessun CV adattato è stato generato per questa candidatura',
  'suivi.originalPosting': 'Annuncio originale',
  'suivi.nextSend': 'Invia la candidatura',
  'suivi.preuveTitre': 'Le mie candidature inviate',
  'suivi.preuveAide': 'Data, datore di lavoro e ruolo, per il centro per l’impiego.',
  'suivi.preuveCopier': 'Copia l’elenco',
  'suivi.preuveCopiee': 'Elenco copiato.',
  'suivi.preuveEchec': 'Copia impossibile da questo browser.',
  'suivi.nextFollowUp': 'Sollecita il {date}',
  'suivi.nextFollowUpDue': 'Sollecita ora (previsto il {date})',
  'suivi.nextInterview': 'Prepara il colloquio',
  'suivi.expiredTitle': 'Scadute',
  'suivi.expiredHint': 'Offerte ritirate dal sito prima dell’invio',
  'suivi.abandon': 'Rinuncia',
  'suivi.abandonConfirm': 'Rinunciare a questa candidatura?',
  'suivi.abandonCancel': 'Annulla',
  'suivi.removeAriaTitle': 'Togli “{title}” dal monitoraggio',
  'suivi.removeAriaName': 'Togli {name} dal monitoraggio',
  'suivi.removedToastTitle': '“{title}” tolta dal monitoraggio',
  'suivi.removedToastName': '{name} tolto dal monitoraggio',
  'veille.periodAll': 'Tutte le date',
  'veille.periodToday': 'Oggi',
  'veille.period7d': 'Ultimi 7 giorni',
  'veille.period30d': 'Ultimi 30 giorni',
  'veille.loading': 'Caricamento dell’osservatorio…',
  'veille.subtitle': 'Tutto ciò che le fonti hanno portato · {n} offerte seguite',
  'veille.subtitleSingular': 'Tutto ciò che le fonti hanno portato · {n} offerta seguita',
  'veille.searchPlaceholder': 'Cerca…',
  'veille.searchAria': 'Cerca',
  'veille.clearSearch': 'Cancella la ricerca',
  'veille.manualEntryButton': 'Inserimento manuale',
  'veille.allCompanies': 'Tutte le aziende',
  'veille.allLocations': 'Tutti i luoghi',
  'veille.allConsultants': 'Tutti i consulenti',
  'veille.periodAria': 'Periodo',
  'veille.statusAria': 'Stato',
  'veille.allStatuses': 'Tutti gli stati',
  'veille.shownPlural': '{n} offerte mostrate',
  'veille.shownSingular': '{n} offerta mostrata',
  'veille.reset': 'Reimposta ({n})',
  'veille.colTitle': 'Offerta',
  'veille.colCompany': 'Azienda',
  'veille.colDetected': 'Rilevata',
  'veille.colStatus': 'Stato',
  'veille.unread': 'Non letta',
  'veille.missionBadge': 'Missione',
  'veille.viewOriginal': 'Vedi l’annuncio originale',
  'veille.manualPlatform': 'inserimento manuale',
  'veille.noMatch': 'Nessuna offerta corrisponde a questi filtri.',
  'veille.resetFilters': 'Reimposta i filtri',
  'veille.evaluating': 'Valutazione…',
  'veille.addedToast': 'Offerta aggiunta, {n} profilo/i valutato/i',
  'veille.addAndEvaluate': 'Aggiungi e valuta',
  'veille.jobTitleLabel': 'Titolo del ruolo',
  'veille.jobTitlePlaceholder': 'Es. Senior Backend Engineer, Java',
  'veille.companyLabel': 'Cliente / azienda',
  'veille.locationLabel': 'Località',
  'veille.optional': 'Facoltativo',
  'veille.briefLabel': 'Capitolato',
  'veille.briefPlaceholder': 'Incolla qui la descrizione completa…',
  'veille.briefHelp': 'Almeno 100 caratteri. L’offerta viene valutata subito.',
  'consultant.loading': 'Caricamento della scheda…',
  'consultant.backToBench': 'Torna al vivaio',
  'consultant.updatedOn': 'aggiornato il {date}',
  'consultant.printPdf': 'Stampa / PDF',
  'consultant.noDocument': 'Nessun documento.',
  'consultant.originalPdf': 'PDF originale',
  'consultant.cvEdit': 'Modifica',
  'consultant.cvSave': 'Salva',
  'consultant.cvSaving': 'Salvataggio…',
  'consultant.cvCancel': 'Annulla',
  'consultant.cvSaved': 'CV salvato',
  'consultant.cvDiscard': 'Abbandonare le modifiche non salvate?',
  'consultant.keywordsTitle': 'Cosa ritorna nelle tue offerte',
  'consultant.keywordsIntroPlural': 'Sulle {n} offerte già valutate per te.',
  'consultant.keywordsIntroSingular': 'Sulla {n} offerta già valutata per te.',
  'consultant.keywordsCovered': 'Cosa copre già il tuo CV',
  'consultant.keywordsMissing': 'Cosa mancava più spesso',
  'consultant.filesTotal': '{n} in totale',
  'consultant.offerArchived': 'offerta archiviata',
  'consultant.fidelityTitle': 'Fedeltà al CV principale: {n} %',
  'consultant.noEvent': 'Ancora nessun evento.',
  'consultant.eventFidelity': ', fedeltà {n} %',
  'consultant.eventClient': ', {client}',
  'sources.addedToast': '{name} aggiunto, {n} offerte inserite',
  'sources.alreadyKnownToast': 'Radar osservava già questo sito ({name}): ora lo segui',
  'sources.noneFollowed': 'Non segui ancora nessun sito. Incolla qui sopra l’indirizzo di una pagina di lavora con noi, o sfoglia i siti che Radar osserva già.',
  'sources.browseTitle': 'Sfoglia i {n} siti già osservati da Radar',
  'sources.browseHelp': 'Sono osservati per altri account. Segui quelli che ti interessano: le loro offerte verranno confrontate con il tuo CV.',
  'sources.browseSearch': 'Cerca un sito o un’azienda',
  'sources.browseNone': 'Nessun sito corrisponde. Aggiungilo con il suo indirizzo, qui sopra.',
  'sources.loading': 'Caricamento delle fonti…',
  'sources.title': 'Fonti',
  'sources.activeSites': '{n} siti attivi',
  'sources.followedSites': '{n} siti seguiti',
  'sources.followedSitesMax': '{n} / {max} siti seguiti',
  'sources.errorCount': '{n} in errore',
  'sources.watchedNightly': 'osservato ogni notte',
  'sources.addTitle': 'Aggiungi un sito, incolla l’URL della sua pagina di lavora con noi',
  'sources.urlPlaceholder': 'https://jobs.esempio.it',
  'sources.urlAria': 'URL della pagina di lavora con noi',
  'sources.detect': 'Rileva',
  'sources.detecting': 'Riconoscimento della piattaforma e prova di estrazione…',
  'sources.unreachablePrefix': 'Pagina',
  'sources.unreachable': 'irraggiungibile',
  'sources.unreachableSuffix': ', controlla l’URL.',
  'sources.unsupportedPrefix': 'Piattaforma',
  'sources.unsupported': 'non ancora supportata',
  'sources.unsupportedSuffix': '. Supportate oggi:',
  'sources.requestExplain': 'Non è finita: richiedi l’attivazione qui sotto. Un sito sconosciuto richiede una riga di configurazione scritta a mano, l’unica cosa che non si indovina. Riceverai un’e-mail quando sarà online.',
  'sources.follow': 'Segui',
  'sources.logoLabel': 'Logo',
  'sources.logoUrlPlaceholder': 'Indirizzo di un’immagine (https://…)',
  'sources.logoSet': 'Usa',
  'sources.logoFile': 'Invia un file',
  'sources.logoAuto': 'Riprendi la favicon del sito',
  'sources.logoHelp': 'Un logo messo a mano non viene più sostituito dalla ricerca automatica. PNG, SVG, ICO, JPEG o WebP, al massimo 512 KB.',
  'sources.logoUpdated': 'Logo aggiornato.',
  'sources.unfollow': 'Non seguire più',
  'sources.followed': '{name}: segui questo sito. Radar legge e valuta le sue offerte, l’avanzamento compare in cima allo schermo.',
  'sources.followedStale': '{name}: segui questo sito. Nessuno lo seguiva, le sue offerte risalgono all’ultima lettura ({date}): Radar lo rilegge ora, poi valuta le sue offerte.',
  'sources.notReadSince': 'Letto il {date}, riletto appena lo segui',
  'sources.neverRead': 'Letto appena lo segui',
  'sources.staleState': 'Offerte del {date}, rilettura in attesa',
  'accueil.sites.staleHelp': 'I siti segnati “non riletto” lo saranno appena avrai finito, prima di valutarne le offerte.',
  'offre.staleSource': 'Letta il {date}, non più riletta: forse è già chiusa',
  'offre.staleShort': 'non riletta dal {date}',
  'offre.republished': 'ripubblicata (ritirata il {date})',
  'offre.republishedMany': 'pubblicata {n} volte in 90 giorni',
  'offre.oldPosting': 'online da {n} giorni',
  'taches.cv': 'Il tuo CV',
  'taches.phase.attente': 'in attesa',
  'taches.phase.lecture': 'lettura delle offerte',
  'taches.phase.classement': 'classificazione per professione',
  'taches.phase.evaluation': 'valutazione delle offerte',
  'taches.phase.relecture': 'rilettura dei siti',
  'taches.unite.relecture': 'siti riletti: {fait} su {total}',
  'taches.unite.lecture': 'pagine lette: {fait} su {total}',
  'taches.unite.classement': 'offerte classificate: {fait} su {total}',
  'taches.unite.evaluation': 'offerte valutate: {fait} su {total}',
  'taches.fini': 'finito, {n} offerta/e valutata/e',
  'taches.finiEnAttente': 'finito, {n} offerta/e valutata/e; {m} non ancora leggibile/i, valutata/e stanotte',
  'taches.erreur': 'interrotto ({message}), riprenderà la notte',
  'sources.unfollowed': '{name}: non segui più questo sito. Le sue offerte spariscono dalle tue schermate, restano per gli altri.',
  'sources.followedLabel': 'Seguito',
  'sources.notFollowedLabel': 'Non seguito',
  'sources.request': 'Richiedi l’attivazione',
  'sources.requesting': 'Invio…',
  'sources.requestNotePlaceholder': 'Facoltativo: un dettaglio, per esempio la pagina che elenca le offerte',
  'sources.requestNoteAria': 'Dettaglio per la richiesta',
  'sources.requestSent': 'Richiesta registrata. Ricevi un’e-mail di conferma, e una seconda quando il sito è online, in genere entro {n} giorni.',
  'sources.requestSentNoMail': 'Richiesta registrata, ma l’e-mail di conferma non è partita. È comunque nell’elenco qui sotto.',
  'sources.requestFailed': 'Richiesta impossibile.',
  'sources.pendingTitle': 'Siti in attesa di attivazione',
  'sources.pendingHelp': 'Richiesti, non ancora osservati. Riceverai un’e-mail appena saranno online.',
  'sources.pendingNoMail': 'nessuna e-mail inviata per questa richiesta',
  'sources.recognizedPrefix': 'Piattaforma riconosciuta:',
  'sources.viaHtml': '(leggendo la pagina)',
  'sources.offersFound': '{n} offerte trovate',
  'sources.preview': 'anteprima',
  'sources.actuallyWatched': 'Portale realmente osservato:',
  'sources.adding': 'Aggiunta…',
  'sources.addToWatch': 'Aggiungi all’osservatorio',
  'sources.addAnyway': 'Aggiungi comunque',
  'sources.colCompany': 'Azienda',
  'sources.colPlatform': 'Piattaforma',
  'sources.colHealth': 'Stato di salute',
  'sources.colLastCheck': 'Ultimo controllo',
  'sources.colOffers': 'Offerte',
  'sources.errorLabel': 'Errore, {detail}',
  'sources.paused': 'In pausa',
  'sources.active': 'Attivo',
  'sources.reactivatedToast': 'Fonte riattivata',
  'sources.pausedToast': 'Fonte messa in pausa',
  'sources.resume': 'Riprendi',
  'sources.pause': 'Pausa',
  'sources.removeTitle': 'Togli dall’osservatorio',
  'sources.removedTitle': 'Tolte dall’osservatorio',
  'sources.removedAt': 'tolta {when}',
  'sources.wouldComeBack': '{n} offerte tornerebbero',
  'sources.restoredToast': '{name} rimessa nell’osservatorio, {n} offerta/e restituita/e',
  'sources.restoreToWatch': 'Rimetti nell’osservatorio',
  'sources.removedToast': '{name} tolta, {n} offerta/e archiviata/e',
  'sources.editTitle': 'Modifica {name}',
  'sources.detecting2': 'Rilevamento…',
  'sources.saving': 'Salvataggio…',
  'sources.updatedToast': 'Fonte aggiornata',
  'sources.save': 'Salva',
  'sources.companyLabel': 'Azienda',
  'sources.companyHelp': 'Il nome mostrato ovunque: sulle offerte, nel monitoraggio e nel nome dei CV esportati. Se resta vuoto, si usa il nome della fonte.',
  'sources.sourceNameLabel': 'Nome della fonte',
  'sources.sourceNameHelp': 'Per orientarti in questo elenco, quando un’azienda ha più portali.',
  'sources.watchedUrlLabel': 'URL osservato',
  'sources.urlWillRedetect': 'La piattaforma verrà rilevata di nuovo a questo indirizzo. Se non viene riconosciuta, non verrà salvato nulla.',
  'sources.currentPlatform': 'Piattaforma attuale: {platform}.',
  'sources.removeConfirmTitle': 'Togliere {name} dall’osservatorio?',
  'sources.removing': 'Rimozione…',
  'sources.removeFromWatch': 'Togli dall’osservatorio',
  'sources.removeConfirmP1': 'Non verrà più interrogata la notte, e le sue {n} offerte escono dall’osservatorio.',
  'sources.removeConfirmP2': 'Non si cancella nulla: i punteggi già calcolati, i dossier generati e le candidature in corso restano intatti, e la fonte torna nell’osservatorio con un clic. È ciò che permette di toglierla senza chiedersi cosa si perde.',
  'decisions.loading': 'Caricamento della pila…',
  'decisions.nothingPending': 'Niente in attesa',
  'decisions.countPlural': '{n} offerte',
  'decisions.countSingular': '{n} offerta',
  'decisions.goodPlural': '{n} buone corrispondenze',
  'decisions.goodSingular': '{n} buona corrispondenza',
  'decisions.lastRun': 'ultima elaborazione {when}',
  'decisions.searchAria': 'Cerca nella pila',
  'decisions.onboardTitle': 'Radar non ha ancora niente da mostrarti',
  'decisions.onboardIntro': 'È normale, il tuo account è appena stato creato. Due cose da fare, una volta, e l’osservazione gira ogni notte senza che tu ci debba pensare.',
  'decisions.onboardStep1Title': 'Carica il tuo CV',
  'decisions.onboardStep1Help': 'Basta un PDF. Radar ne estrae le tue esperienze e competenze, circa venti secondi. È questo CV il riferimento di tutti i confronti.',
  'decisions.onboardStep1Action': 'Carica un PDF',
  'decisions.onboardStep2Title': 'Scegli i siti da osservare',
  'decisions.onboardStep2Help': 'Incolla l’indirizzo di una pagina di lavora con noi. Radar riconosce da solo la piattaforma e ti mostra cosa riesce a leggere prima che tu confermi.',
  'decisions.onboardStep2Action': 'Aggiungi un sito',
  'decisions.onboardNote': 'La prima notte di osservazione parte appena aggiunto il primo sito. Puoi chiudere, Radar continua.',
  'decisions.pileZeroText': 'Tutto ciò che è arrivato è stato deciso. Le proposte in corso sono nel',
  'decisions.pileZeroTracking': 'monitoraggio',
  'decisions.pileZeroText2': 'e tutto ciò che è stato raccolto resta consultabile nell’',
  'decisions.pileZeroWatch': 'osservatorio',
  'decisions.tierAria': 'Livello di corrispondenza',
  'decisions.allScores': 'Tutti i punteggi',
  'decisions.selectAll': 'Seleziona tutto',
  'decisions.selectedPlural': '{n} selezionate',
  'decisions.selectedSingular': '{n} selezionata',
  'decisions.batchLater': 'rimandate',
  'decisions.later': 'Più tardi',
  'decisions.batchSkipped': 'scartate',
  'decisions.skip': 'Scarta',
  'decisions.deselect': 'Deseleziona',
  'decisions.selectHint': 'Spunta più offerte per scartarle in una volta. Aprire un’offerta non la toglie dalla pila.',
  'decisions.shownOfTotal': '{shown} su {total}',
  'decisions.noMatch': 'Nessuna offerta della pila corrisponde a questi filtri.',
  'decisions.resetShort': 'Reimposta',
  'decisions.selectOffer': 'Seleziona {title}',
  'decisions.laterTitle': 'La rivedrò più tardi',
  'decisions.reopenedToast': '“{title}” ripresa, torna da decidere',
  'decisions.skippedTitle': 'Scartate',
  'decisions.skippedHint': 'Non si elimina nulla, puoi tornare sulla decisione',
  'decisions.skippedAt': 'scartata {when}',
  'decisions.reopenTitle': 'Rimetti nella pila',
  'decisions.reopen': 'Riprendi',
  'decisions.skippedToast': '“{title}” scartata',
  'decisions.laterToast': '“{title}” rimandata',
  'decisions.appliedToast': '“{title}” aggiunta alle tue candidature',
  'decisions.sortButton': 'Seleziona ({n})',
  'decisions.thresholdLabel': 'Mostrami a partire da',
  'decisions.thresholdEffect': '{n} offerte su {total} da selezionare',
  'decisions.thresholdSaved': 'Soglia salvata: {n}',
  'tri.title': 'Seleziona le mie opportunità',
  'tri.progress': '{n} su {total}',
  'tri.close': 'Chiudi',
  'tri.doneTitle': 'Pila selezionata',
  'tri.doneText': '{n} offerte selezionate. Quelle che segui sono tra le tue candidature.',
  'tri.noProfile': 'Nessun punteggio su questa offerta: apri la scheda per valutarla.',
  'decisions.batchToast': '{n} offerta/e: {action}',
  'decisions.tierGood': 'Buona corrispondenza',
  'decisions.tierGoodRange': '70 e oltre',
  'decisions.tierMid': 'Da verificare',
  'decisions.tierMidRange': 'da 40 a 69',
  'decisions.tierLow': 'Corrispondenza debole',
  'decisions.tierLowRange': 'sotto 40',
  'offre.loading': 'Caricamento dell’offerta…',
  'offre.notFound': 'Offerta non trovata',
  'offre.statusAriaLabel': 'Decisione su questa offerta',
  'offre.kindMission': 'Missione',
  'offre.kindJob': 'Impiego',
  'offre.reperee': 'Individuata il {date}',
  'offre.avisEnFrancais': 'Questo parere è stato scritto in francese.',
  'offre.avisEnAnglais': 'Questo parere è stato scritto in inglese.',
  'offre.avisEnNeerlandais': 'Questo parere è stato scritto in olandese.',
  'offre.avisEnItalien': 'Questo parere è stato scritto in italiano.',
  'offre.avisEnEspagnol': 'Questo parere è stato scritto in spagnolo.',
  'offre.avisRetraduit': 'Radar lo riscrive nella tua lingua entro qualche notte.',
  'offre.avisFaux': 'Questo parere ti sembra sbagliato?',
  'offre.avisFauxMerci': 'Grazie, ne abbiamo preso nota.',
  'offre.avisPour': 'Per te',
  'offre.avisAVerifier': 'Da verificare',
  'offre.avisAdapte': 'Con un CV adattato: {n}',
  'offre.exigenceCouverte': 'Coperto',
  'offre.exigenceAConfirmer': 'Da confermare',
  'offre.exigenceManquante': 'Mancante',
  'offre.detailScore': 'Il dettaglio del punteggio',
  'offre.annonceComplete': 'L’annuncio completo',
  'offre.evaluatedProfilesPlural': '{n} profili valutati',
  'offre.evaluatedProfilesSingular': '{n} profilo valutato',
  'offre.originalPosting': 'Annuncio originale',
  'offre.deadlineValue': 'Scadenza: {value}',
  'offre.startValue': 'Inizio desiderato: {value}',
  'offre.endValue': 'Fine prevista: {value}',
  'offre.notSetFem': 'non indicata',
  'offre.notSetMasc': 'non indicato',
  'offre.proposalsPlural': '{n} proposte presentate',
  'offre.proposalsSingular': '{n} proposta presentata',
  'offre.proposalsUnset': 'numero di proposte non indicato',
  'offre.frameworkUnset': 'accordo quadro non indicato',
  'offre.collapseDesc': 'Riduci la descrizione',
  'offre.expandDesc': 'Leggi la descrizione completa',
  'offre.noDescriptionCaptured': 'Nessuna descrizione recuperata.',
  'offre.applicationsHeader': 'Candidature',
  'offre.proposedAgo': 'proposto {when}',
  'offre.viewFileLink': 'vedi il dossier',
  'offre.candidats': 'Candidati',
  'offre.aucunCandidat': 'Ancora nessun profilo valutato.',
  'offre.compareName': 'Confronta {name}',
  'offre.scoreAriaLabel': '{name}: {score} su 100',
  'offre.onDemandTitle': 'Valutato su tua richiesta, fuori dalla preselezione',
  'offre.gainAfterAdaptation': '↑ {gain} dopo l’adattamento',
  'offre.fileGeneratedTitle': 'Dossier generato',
  'offre.compareHintBase': 'Spunta due o più profili per confrontarli fianco a fianco,',
  'offre.compareOr': 'oppure',
  'offre.compareBest': 'confronta i {n} migliori',
  'offre.compareFreeSuffix': ' è già gratuito e immediato, è tutto nel database.',
  'offre.compareMax': 'Al massimo {n} profili in un confronto',
  'offre.journal': 'Registro dell’offerta',
  'offre.generatingFile': 'Generazione del dossier di {name}…',
  'offre.generatingHelp': 'Riscrittura fedele del CV per l’offerta. Ogni modifica verrà verificata.',
  'offre.comparedCount': '{n} profili confrontati su questa offerta',
  'offre.closeComparison': 'Chiudi il confronto',
  'offre.generateTheirFile': 'Genera il suo dossier',
  'offre.applyTitle': 'Ti candidi?',
  'offre.applyBody1': 'la aggiunge alle tue candidature, senza calcolare nulla.',
  'offre.adaptCvLabel': 'Adatta il mio CV',
  'quota.restantes': 'Ancora {n} adattamenti su {max} questa settimana',
  'quota.aZero': 'Nessun adattamento rimasto questa settimana. Il contatore riparte lunedì.',
  'offre.applyBody2': 'lo riscrive per questa offerta: è l’unico passo che costa qualcosa, e avviene solo se lo chiedi.',
  'offre.presentTitle': 'Pronto a presentare {name}?',
  'offre.presentBody1': 'crea la candidatura e la segue, senza chiamare nulla.',
  'offre.theFileLabel': 'Il dossier',
  'offre.presentBody2': '(CV riscritto per l’offerta + audit) è l’unico passo costoso, e viene generato solo se lo chiedi.',
  'offre.alreadyInApplications': 'già nelle tue candidature',
  'offre.alreadyProposed': 'già proposto',
  'offre.about15s': '~15 s',
  'offre.generateAdaptedFile': 'Genera il dossier adattato',
  'offre.emptyAnalysis': 'Ancora nessuna valutazione.',
  'offre.statusSkippedToast': 'Offerta scartata',
  'offre.statusLaterToast': 'Messa da parte, è nel monitoraggio',
  'offre.statusReopenedToast': 'Rimessa tra le decisioni da prendere',
  'offre.neighboursTitle': 'Profili delle categorie vicine',
  'offre.neighboursHelp': 'Non condividono la categoria di questa offerta, ma una categoria sorella. Non vengono valutati automaticamente.',
  'offre.scoredToast': '{name}: {score}/100',
  'offre.evaluate': 'Valuta',
  'offre.notYetEvaluated': 'Questa offerta non è ancora stata valutata per te',
  'offre.evaluatingLabel': 'Valutazione…',
  'offre.alreadyScoredToast': 'Già valutata: {score}/100',
  'offre.evaluatedToast': 'Valutata: {score}/100',
  'offre.evaluateMyProfile': 'Valuta il mio profilo',
  'offre.evaluateHelp': '~3 s, una chiamata all’IA. Il risultato viene conservato.',
  'offre.evaluateAnother': 'Valuta un altro profilo',
  'offre.employerUnknown': 'Datore di lavoro non indicato',
  'offre.employerViaSource': 'tramite {source}',
  'offre.radarSkipToast': 'Non fa per me: non tornerà',
  'offre.radarLaterToast': 'Tenuta in Le mie offerte. Radar te la ricorderà lunedì {date} se è ancora online.',
  'offre.radarReopenToast': 'Decisione annullata',
  'decisions.skippedToastRadar': '“{title}”: non fa per me',
  'decisions.reopenedToastRadar': '“{title}” è di nuovo tra le tue opportunità',
  'sources.colState': 'Stato',
  'sources.stateOk': 'OK',
  'sources.broken': 'Guasto',
  'sources.brokenSince': 'Guasto dal {date}',
  'veille.notScored': 'Non valutata',
  'offre.appliedToast': 'Aggiunta alle tue candidature',
  'offre.descriptionTitle': 'Il ruolo',
  'offre.behindTheScenes': 'Come Radar ha trattato questa offerta',
  'offre.generatingMyCv': 'Adattamento del tuo CV…',
  'config.loading': 'Caricamento delle impostazioni…',
  'config.saving': 'Salvataggio…',
  'config.savedToast': 'Impostazioni salvate',
  'config.save': 'Salva',
  'config.sliderAria': 'Punteggio minimo per entrare nella pila',
  'config.scaleLow': '← vedere tutto, anche ciò che non va bene',
  'config.scaleHigh': 'vedere solo le corrispondenze migliori →',
  'config.computingEffect': 'Calcolo dell’effetto…',
  'config.thresholdReference': 'Riferimento: il motore giudica “no” sotto 40, “forse” fino a 68, “sì” da 70.',
  'config.optimizationLabel': 'Livello di adattamento',
  'config.optimizationBalanced': 'Equilibrato',
  'config.optimizationTargeted': 'Mirato',
  'config.toneLabel': 'Tono',
  'config.toneSober': 'Sobrio',
  'config.toneDynamic': 'Dinamico',
  'config.toneExecutive': 'Executive',
  'config.lengthLabel': 'Lunghezza',
  'config.languageLabel': 'Lingua',
  'config.langue.auto': 'Quella dell’offerta',
  'config.langue.autoEffet': 'La lingua dell’offerta se il tuo CV dice che la parli, altrimenti l’inglese.',
  'config.langue.fr': 'Francese',
  'config.langue.frEffet': 'Sempre in francese.',
  'config.langue.en': 'Inglese',
  'config.langue.enEffet': 'Sempre in inglese.',
  'config.length1Page': '1 pagina',
  'config.length2Pages': '2 pagine',
  'config.lengthUnlimited': 'Senza limite',
  'config.questionsLabel': 'Domande prima di generare',
  'config.questionsOnce': 'Una volta per offerta',
  'config.questionsAlways': 'A ogni generazione',
  'config.niveau.fidele': 'Fedele',
  'config.niveau.audacieux': 'Audace',
  'config.niveau.fideleEffet': 'Tiene tutte le tue righe, le riscrive e le riordina per l’offerta.',
  'config.niveau.equilibreEffet': 'Riscrive liberamente e accorcia un po’ ciò che serve meno all’offerta.',
  'config.niveau.cibleEffet': 'Tiene ciò che serve all’offerta, accorcia il resto.',
  'config.niveau.audacieuxEffet': 'Può affermare ciò che l’offerta chiede e che il tuo CV non dice.',
  'config.ton.sobreEffet': 'Frasi dirette, senza superlativi.',
  'config.ton.dynamiqueEffet': 'Verbi d’azione, risultati in primo piano.',
  'config.ton.executifEffet': 'Guida, visione, responsabilità.',
  'config.longueur.unePageEffet': 'Solo l’essenziale per questa offerta.',
  'config.longueur.deuxPagesEffet': 'Conciso, senza sacrificare tutto.',
  'config.longueur.sansLimiteEffet': 'Nessun vincolo di lunghezza.',
  'config.questions.aide': 'Su ciò che l’offerta chiede e che il tuo CV non dice, poi sul taglio della lettera.',
  'config.questions.uneFoisEffet': 'Poste alla prima generazione per un’offerta, poi non più.',
  'config.questions.toujoursEffet': 'Riproposte prima di ogni CV e di ogni lettera.',
  'compte.motDePasse': 'Password',
  'compte.changer': 'Cambia',
  'compte.telecharger': 'Scarica i miei dati',
  'compte.supprimer': 'Elimina il mio account',
  'compte.supprimerAide': 'Il tuo CV, le tue candidature, i tuoi CV adattati e le tue impostazioni vengono cancellati. Le fatture restano su Stripe. È definitivo.',
  'compte.supprimerConfirmer': 'Elimina definitivamente',
  'compte.actuel': 'Password attuale',
  'compte.motDePasseAide': 'Almeno {n} caratteri. I tuoi altri dispositivi verranno disconnessi.',
  'compte.enregistrer': 'Cambia la password',
  'compte.actuelFaux': 'La password attuale non è corretta.',
  'config.signature': 'Firma',
  'config.authorLabel': 'Il tuo nome',
  'radar.moi': 'Io',
  'radar.menuAria': 'Il mio account',
  'reglages.titre': 'Impostazioni',
  'mails.quand': 'Quando',
  'marche.offres1': '1 offerta come la tua questo mese',
  'marche.offres': '{n} offerte come la tua questo mese',
  'marche.chez1': 'presso 1 datore di lavoro',
  'marche.chez': 'presso {e} datori di lavoro',
  'marche.salaire': 'Stipendio indicato: da {min} a {max} €.',
  'sugg.employeur': '{n} rifiuti “Non questo datore di lavoro” per {nom}.',
  'sugg.employeurAction': 'Silenzia {nom}',
  'sugg.regions': '{n} rifiuti “Troppo lontano”.',
  'sugg.regionsAction': 'Scegli le tue regioni',
  'sugg.salaire': '{n} rifiuti per lo stipendio.',
  'sugg.salaireAction': 'Imposta un minimo',
  'sugg.metier': '{n} rifiuti “Non è la mia professione”.',
  'sugg.metierAction': 'Rivedi le tue professioni',
  'sugg.seuil': 'Da una settimana niente ha superato la tua soglia. Le tue offerte migliori sono a {n}.',
  'sugg.seuilAction': 'Passa a {seuil}',
  'sugg.seuilFait': 'Soglia portata a {seuil}.',
  'cherche.placeholder': 'Cerca in tutte le offerte seguite',
  'cherche.rien': 'Nessuna offerta.',
  'tri.ouvrir': 'Selezione rapida',
  'tri.titre': 'Selezione rapida · {n} / {total}',
  'tri.voir': 'Vedi',
  'tri.plusTard': 'Più tardi',
  'tri.pasPourMoi': 'Non fa per me',
  'tri.passer': 'Successiva senza decidere',
  'tri.fermer': 'Chiudi',
  'tri.fini': 'È tutto selezionato.',
  'tri.plusTardOk': 'Tenuta per più tardi.',
  'tri.pasPourMoiOk': 'Scartata.',
  'excl.cdd': 'Tempo determinato',
  'excl.interim': 'Interinale',
  'excl.freelance': 'Freelance',
  'excl.stage': 'Tirocinio',
  'excl.junior': 'Junior',
  'excl.senior': 'Senior',
  'excl.langues': 'Lingue richieste che non parlo',
  'excl.salaire': 'Stipendio lordo annuo minimo',
  'excl.contrats': 'Contratti accettati',
  'excl.cdi': 'Tempo indeterminato',
  'excl.confirme': 'Esperto',
  'excl.niveaux': 'Livelli che mi vanno bene',
  'excl.teletravail': 'Telelavoro',
  'excl.temps': 'Orario di lavoro',
  'excl.tempsPlein': 'Tempo pieno',
  'excl.tempsPartiel': 'Part-time o 4/5',
  'excl.peuImporte': 'Indifferente',
  'excl.hybride': 'Almeno ibrido',
  'excl.salaireAucun': 'Nessuno',
  'excl.salaireAutre': 'Altro…',
  'excl.k': '{n} k€',
  'excl.parAn': '€ lordi all’anno',
  'excl.jeParle': 'Parlo',
  'excl.parle.fr': 'Francese',
  'excl.parle.nl': 'Olandese',
  'excl.parle.en': 'Inglese',
  'excl.parle.de': 'Tedesco',
  'reglages.cherche.titre': 'Cosa cerco',
  'reglages.cherche.aide': 'Vale per le e-mail e la home. Un’offerta che non dice nulla su un punto passa sempre.',
  'reglages.regions': 'Dove',
  'reglages.ecrit.titre': 'Quando Radar mi scrive',
  'reglages.avance': 'Avanzate',
  'reglages.compte.titre': 'Il mio account',
  'reglages.mails.coupesIci': 'Le e-mail sono disattivate. Si riattivano in “Il mio account”.',
  'mails.matin': 'La mattina stessa',
  'mails.hebdo': 'Solo il lunedì',
  'mails.quels': 'Quali e-mail',
  'mails.mots': 'Parole seguite',
  'mails.motsAide': 'Una nuova offerta che ne contiene una ti arriva per e-mail, qualunque sia il suo punteggio. Al massimo dieci, separate da virgole.',
  'mails.motsExemple': 'Kubernetes, product owner',
  'mails.lundi': 'Riepilogo del lunedì',
  'mails.relance': 'Sollecito dopo 7 giorni',
  'mails.accueil': 'Soglia della home',
  'mails.commeMails': 'Come le e-mail ({n})',
  'mails.saved': 'Salvato.',
  'mails.prioritaire': 'Prioritario',
  'mails.muet': 'Silenziato',
  'mails.prioritaireAide': 'Ogni offerta nelle tue professioni ti arriva per e-mail.',
  'mails.muetAide': 'Nessuna e-mail per questo datore di lavoro.',
  'reglages.mails.coupes': 'Non ricevi più le e-mail di Radar. Continua a osservare: le tue offerte restano qui.',
  'reglages.mails.reactiver': 'Ricevi di nuovo le e-mail',
  'reglages.mails.couper': 'Non ricevere più e-mail',
  'rythme.aria': 'Ritmo delle e-mail',
  'rythme.discret.nom': 'Discreto',
  'rythme.discret.seuil': '80 e oltre',
  'rythme.discret.desc': 'Solo le offerte molto vicine al tuo CV.',
  'rythme.equilibre.nom': 'Equilibrato',
  'rythme.equilibre.seuil': '70 e oltre',
  'rythme.equilibre.desc': 'Le offerte vicine al tuo CV.',
  'rythme.actif.nom': 'Cerco attivamente',
  'rythme.actif.seuil': '60 e oltre',
  'rythme.actif.desc': 'Anche le offerte un po’ più lontane.',
  'rythme.estimationZero': 'Nessuna offerta negli ultimi 30 giorni',
  'rythme.estimationUn': '1 offerta negli ultimi 30 giorni',
  'rythme.estimationPlus': '{n} offerte negli ultimi 30 giorni',
  'rythme.note': 'Contate sui tuoi datori di lavoro negli ultimi 30 giorni. Una notte, al massimo un’e-mail.',
  'rythme.perso': 'La tua soglia attuale, {n}, è stata impostata a mano. Scegliere un ritmo la sostituisce.',
  'accueil2.sansCv': 'Radar confronta ogni offerta con il tuo CV. Senza CV non ha niente da mostrarti.',
  'accueil2.sansCvAction': 'Carica il mio CV',
  'accueil2.titreNouvelleUn': 'Una nuova offerta supera la tua soglia di {seuil}.',
  'accueil2.titreNouvellesPlus': '{n} nuove offerte superano la tua soglia di {seuil}.',
  'accueil2.titreAttenteUn': 'Un’offerta sopra {seuil} ti aspetta.',
  'accueil2.titreAttentePlus': '{n} offerte sopra {seuil} ti aspettano.',
  'accueil2.titreCalme': 'Niente di nuovo sopra {seuil}.',
  'accueil2.aucunSuivi': 'Non segui ancora nessun datore di lavoro.',
  'accueil2.aFaire': 'Da fare',
  'accueil2.finFile': 'È tutto per oggi.',
  'file.aria': 'Offerte da selezionare',
  'file.position': 'Offerta {rang} di {total}',
  'file.suivante': 'Successiva',
  'file.terminer': 'Fine',
  'accueil2.etat': 'Radar ha riletto i tuoi siti {quand}.',
  'accueil2.etatPremiere': 'Prima lettura dei tuoi siti stanotte.',
  'accueil2.lundi': 'Riepilogo lunedì, anche senza novità.',
  'accueil2.mailsCoupes': 'Non ricevi e-mail.',
  'accueil2.mailsReactiver': 'Riattivale',
  'accueil2.pause': 'E-mail in pausa fino al {date}',
  'accueil2.reprendre': 'Riprendi ora',
  'pause.titre': 'Fai una pausa',
  'pause.uneSemaine': '1 settimana',
  'pause.semaines': '{n} settimane',
  'pause.jusqua': 'In pausa fino al {date}',
  'accueil2.pourVous': 'Per te',
  'accueil2.pourVousPlus': 'Le {n} migliori su {total}.',
  'accueil2.nouvelle': 'Nuova',
  'accueil2.via': 'tramite {site}',
  'accueil2.atoutsLabel': 'Per te:',
  'accueil2.manquesLabel': 'Da verificare:',
  'accueil2.tranchee': '{etat}: {titre}',
  'accueil2.dessousTitre': 'Appena sotto',
  'accueil2.plusProches': 'Le più vicine',
  'accueil2.dessousUn': '1 offerta tra {min} e {max} questa settimana',
  'accueil2.dessousPlus': '{n} offerte tra {min} e {max} questa settimana',
  'accueil2.dessousNote': 'Non ti sono state inviate per e-mail.',
  'accueil2.changerRythme': 'Cambia il mio ritmo',
  'accueil2.choisirEmployeurs': 'Scegli i miei datori di lavoro',
  'accueil2.empErreur': 'Illeggibile al momento. Il team è avvisato, non devi fare nulla.',
  'accueil2.empAnnonces': 'Sito di annunci: {n} offerte nelle tue professioni, la migliore a {m}',
  'accueil2.empAnnoncesRien': 'Sito di annunci: niente nelle tue professioni per ora',
  'accueil2.empAnnoncesUn': 'Sito di annunci: 1 offerta nelle tue professioni, a {m}',
  'accueil2.empRecrutePlus': 'Assume nelle tue professioni: {n} offerte, la migliore a {m}',
  'accueil2.empRecruteUn': 'Assume nelle tue professioni: 1 offerta, a {m}',
  'accueil2.empCalme': 'Tranquillo nelle tue professioni.',
  'accueil2.enCoursUn': '1 candidatura in corso',
  'accueil2.enCoursPlus': '{n} candidature in corso',
  'bienvenue.etape': 'Passo {n} di 3',
  'bienvenue.cv.titre': 'Prima di tutto, il tuo CV',
  'bienvenue.cv.sous': 'Radar lo legge una volta, poi lo usa per confrontare ogni offerta. Resta privato.',
  'bienvenue.essai': 'Radar è gratuito per un mese, senza carta.',
  'bienvenue.cv.extension': 'La tua estensione ha già il tuo CV.',
  'bienvenue.cv.reprendre': 'Riprendilo',
  'bienvenue.cv.reprendreEchec': 'Impossibile leggere il CV dell’estensione.',
  'ext.installee': 'La tua estensione è installata.',
  'ext.connecter': 'Collegala',
  'ext.connectee': 'Estensione collegata.',
  'ext.echec': 'Il collegamento non è riuscito. Riprova.',
  'ext.echecSansCv': 'Carica prima il tuo CV in Radar.',
  'bienvenue.cv.depot': 'Trascina qui il tuo CV in PDF',
  'bienvenue.cv.ou': 'oppure tocca per scegliere un file',
  'bienvenue.cv.lecture': 'Radar legge il tuo CV, una ventina di secondi…',
  'bienvenue.cv.lu': 'Il tuo CV è stato letto.',
  'bienvenue.cv.luNom': 'Il tuo CV è stato letto: {nom}.',
  'bienvenue.cv.metiers': 'Radar cercherà ruoli da',
  'bienvenue.cv.metiersAide': 'Togli ciò che non ti riguarda, aggiungi ciò che manca. Radar valuta solo le offerte di queste professioni.',
  'bienvenue.cv.suivant': 'Sono proprio io',
  'bienvenue.emp.titre': 'Da chi diresti di sì domani?',
  'bienvenue.emp.sous': 'Scegli fino a {max} siti. Radar rilegge le loro offerte ogni notte. Sono ordinati secondo le tue professioni.',
  'bienvenue.emp.sousSansMax': 'Radar rilegge le loro offerte ogni notte. Sono ordinati secondo le tue professioni.',
  'bienvenue.emp.dansMetiers': '{n} nelle tue professioni',
  'bienvenue.emp.rien': 'Niente nelle tue professioni oggi',
  'bienvenue.emp.annoncesTitre': 'Siti di annunci',
  'bienvenue.emp.annoncesAide': 'Pubblicano per centinaia di datori di lavoro, e Radar ne tiene solo le tue professioni. Già spuntati: è da loro che arriva la maggior parte delle buone offerte.',
  'bienvenue.emp.employeursTitre': 'Datori di lavoro',
  'bienvenue.emp.manque': 'Il tuo datore di lavoro non c’è? Aggiungi l’indirizzo della sua pagina di lavora con noi dalla scheda Datori di lavoro, quando il tuo radar sarà pronto.',
  'bienvenue.continuer': 'Continua',
  'bienvenue.retour': 'Indietro',
  'bienvenue.rythme.titre': 'Quando vuoi essere disturbato?',
  'bienvenue.rythme.pasEncore': 'Radar sta confrontando le offerte dei tuoi siti con il tuo CV. Da domani vedrai nelle impostazioni quante ne invia ogni ritmo.',
  'bienvenue.fin': 'Attiva il mio radar',
  'offre.vpQuestion': 'Ti candidi?',
  'offre.vpOui': 'Sì, prepara il mio CV',
  'offre.vpCvPret': 'Il tuo CV è pronto.',
  'offre.vpSansAdapter': 'Mi candido senza adattare il CV',
  'suivi.aDecider': 'Le tue offerte tenute',
  'suivi.aDeciderAide': 'Tenute dall’estensione o aggiunte a mano.',
  'suivi.gardeeLe': 'Tenuta il {date}',
  'regions.question': 'Dove accetti di lavorare?',
  'regions.aide': 'Niente di spuntato: ovunque. Un’offerta altrove non viene mai inviata per e-mail, ma resta visibile presso il suo datore di lavoro. Un’offerta senza luogo noto passa sempre.',
  'regions.aria': 'Regioni',
  'regions.bruxelles': 'Bruxelles',
  'regions.wallonie': 'Vallonia',
  'regions.flandre': 'Fiandre',
  'regions.luxembourg': 'Lussemburgo',
  'regions.etranger': 'Fuori da Belgio e Lussemburgo',
  'filtre.titre': 'Cosa seguire presso {nom}?',
  'filtre.aide': '{n} offerte online. Spunta almeno una zona o una lingua.',
  'filtre.aidePetit': '{n} offerte online. Niente di spuntato: tutto.',
  'filtre.aideTraduite': '{n} offerte, pubblicate ognuna in più lingue. Scegline una.',
  'filtre.lecture': 'Radar legge {n} offerte per notte, le più recenti prima.',
  'emp.enLecture': 'Lettura in corso: le più recenti prima.',
  'filtre.zones': 'Dove',
  'filtre.langues': 'Lingua dell’annuncio',
  'filtre.suivre': 'Segui',
  'filtre.enregistrer': 'Salva',
  'filtre.enregistre': 'Filtro salvato.',
  'filtre.changer': 'Cambia il filtro',
  'filtre.vide': 'Nessuna zona né lingua leggibile su questo sito.',
  'zones.brabant-wallon': 'Brabante Vallone',
  'zones.hainaut': 'Hainaut',
  'zones.liege': 'Liegi',
  'zones.luxembourg-be': 'Provincia del Lussemburgo',
  'zones.namur': 'Namur',
  'zones.anvers': 'Anversa',
  'zones.brabant-flamand': 'Brabante Fiammingo',
  'zones.flandre-occidentale': 'Fiandre Occidentali',
  'zones.flandre-orientale': 'Fiandre Orientali',
  'zones.limbourg': 'Limburgo',
  'zones.france': 'Francia',
  'zones.pays-bas': 'Paesi Bassi',
  'zones.allemagne': 'Germania',
  'zones.suisse': 'Svizzera',
  'zones.autre-pays': 'Altri paesi',
  'langues.fr': 'Francese',
  'langues.nl': 'Olandese',
  'langues.en': 'Inglese',
  'langues.de': 'Tedesco',
  'accueil2.horsRegionsUn': '1 altra offerta sopra {seuil} è fuori dalle tue regioni.',
  'accueil2.horsRegionsPlus': '{n} altre offerte sopra {seuil} sono fuori dalle tue regioni.',
  'accueil2.exclueUn': '1 offerta scartata dai tuoi criteri.',
  'accueil2.excluesPlus': '{n} offerte scartate dai tuoi criteri.',
  'accueil2.changerCriteres': 'I tuoi criteri',
  'accueil2.changerRegions': 'Cambia le mie regioni',
  'emp.calmeDepuis': 'Tranquillo nelle tue professioni. Ultima offerta {n} settimane fa.',
  'raison.question': 'Perché? (facoltativo)',
  'aide.code.bouton': 'Mostra un codice di accesso',
  'aide.code.aide': 'Nell’estensione, Opzioni, “Accedi con un codice Radar”: digita questo codice. Nessuna password da ridigitare. Valido 10 minuti, una sola volta.',
  'aide.code.aria': 'Codice di accesso dell’estensione',
  'aide.pont.ok': 'Estensione collegata. Puoi chiudere questa scheda.',
  'aide.pont.echec': 'L’estensione non è riuscita a collegarsi. Riprova dall’estensione.',
  'aideR.intro': 'L’estensione, e cosa fare quando qualcosa si blocca.',
  'aideR.ext.titre': 'L’estensione',
  'aideR.ext.lead': 'Il tuo punteggio su ogni offerta, LinkedIn compreso.',
  'aideR.ext.telephone': 'Si installa sul computer, in Chrome. Apri Radar sul tuo computer, poi “Aiuto ed estensione”.',
  'aideR.ext.dejaInstallee': 'Già installata? Collegala',
  'aideR.ext.pasInstallee': 'Non ancora installata? Installala',
  'aideR.ext.pasDeBouton': 'Nessun pulsante “Collega con Radar”? Usa un codice:',
  'aideR.ext.connectee': 'Estensione collegata',
  'aideR.ext.nonConnectee': 'L’estensione non è collegata',
  'aideR.ext.rienEnvoye': 'Ancora nessuna offerta inviata tramite lei.',
  'aideR.ext.dernierEnvoi': 'Ultimo invio: {date}.',
  'aideR.ext.ailleurs': 'Su LinkedIn e Indeed si attiva da sola. Altrove, mostrale il sito una volta:',
  'demo.pause': 'Pausa',
  'demo.lecture': 'Riproduci',
  'demo.reduit': 'Animazione disattivata: “riduci animazioni” è attivo.',
  'demo.annuler': 'Annulla',
  'demo.refuser': 'Rifiuta',
  'demo.autoriser': 'Consenti',
  'demo.install.titre': 'Installa e fissa',
  'demo.install.aria': 'Animazione: sul Chrome Web Store, cliccare “Aggiungi a Chrome”, confermare, poi aprire il pezzo di puzzle e fissare l’estensione. La sua icona compare nella barra.',
  'demo.install.e1': '“Aggiungi a Chrome”',
  'demo.install.e2': '“Aggiungi estensione”',
  'demo.install.e3': 'Il pezzo di puzzle, poi la puntina',
  'demo.install.slogan': 'Il tuo punteggio su ogni offerta',
  'demo.install.dlgTitre': 'Aggiungere “AI Job Fit”?',
  'demo.install.dlgTexte': 'Potrà leggere le offerte che apri.',
  'demo.install.menu': 'Estensioni',
  'demo.install.ajouter': 'Aggiungi estensione',
  'demo.ac.bouton': 'Attiva su questo sito',
  'demo.ac.emp': 'Ospedale Esempio · Torino',
  'demo.co.titre': 'Collega a Radar',
  'demo.co.aria': 'Animazione: nelle opzioni dell’estensione, cliccare “Hai un account Radar?”, poi “Collega con Radar”, consentire. Radar conferma in una scheda, e il CV arriva nell’estensione.',
  'demo.co.e1': '“Hai un account Radar?”',
  'demo.co.e2': '“Collega con Radar”, poi “Consenti”',
  'demo.co.e3': 'Radar conferma in una scheda',
  'demo.co.e4': 'Il tuo CV è nell’estensione',
  'demo.co.import': 'Importa il tuo CV per iniziare',
  'demo.co.depot': 'Carica il tuo CV',
  'demo.co.lien': 'Hai un account Radar? Accedi',
  'demo.co.compte': 'Ho un account Radar',
  'demo.co.bouton': 'Collega con Radar',
  'demo.co.ouBien': 'Oppure: password, o codice Radar',
  'demo.co.perm': 'Consentire l’accesso a Radar?',
  'demo.co.fermer': 'Puoi chiudere questa scheda.',
  'demo.co.cv': 'Il tuo CV arriva da Radar',
  'demo.co.nom': 'Il tuo nome',
  'demo.co.metier': 'La tua professione',
  'demo.co.bouton2': '“Salva in Radar” compare su ogni offerta.',
  'demo.ac.titre': 'Attiva su un sito sconosciuto',
  'demo.ac.aria': 'Animazione: sull’annuncio di un sito di un datore di lavoro, cliccare l’icona dell’estensione, poi “Attiva su questo sito”, consentire. Il punteggio compare sull’annuncio.',
  'demo.ac.e1': 'L’icona dell’estensione',
  'demo.ac.e2': '“Attiva su questo sito”',
  'demo.ac.e3': '“Consenti”, una volta per sito',
  'demo.ac.e4': 'Il punteggio compare sull’annuncio',
  'demo.ac.poste': 'Analista finanziario (M/F/X)',
  'demo.ac.pasAcces': 'Non ancora attiva su questo sito.',
  'demo.ac.perm': 'Consentire su questo sito?',
  'demo.ac.profil': 'Buon profilo',
  'demo.ac.adapter': 'Adatta il mio CV',
  'demo.ac.enregistrer': 'Salva in Radar',
  'demo.emp.titre': 'Un datore di lavoro non ancora seguito',
  'demo.emp.aria': 'Animazione: chiedi l’attivazione, un’e-mail conferma subito, una seconda e-mail dice che il datore di lavoro è online, in genere entro una settimana.',
  'demo.emp.l1': 'Fai la richiesta',
  'demo.emp.l1s': '“Richiedi l’attivazione”',
  'demo.emp.l2': 'Un’e-mail conferma',
  'demo.emp.l2s': 'subito',
  'demo.emp.l3': 'È online',
  'demo.emp.l3s': 'in genere entro una settimana',
  'aideR.faq.titre': 'Quando qualcosa si blocca',
  'aideR.q.score': 'Nessun punteggio su un annuncio',
  'aideR.r.score': 'Su un sito che non conosce, l’estensione aspetta il tuo consenso. Una volta per sito:',
  'aideR.r.scoreTel': 'Su un sito che non conosce, l’estensione aspetta il tuo consenso: clicca la sua icona, poi “Attiva su questo sito”. Una volta per sito.',
  'aideR.q.reconnait': 'L’estensione non mi riconosce più',
  'aideR.r.reconnait': 'Nuovo computer, password cambiata: ricollegala. Nelle sue opzioni, “Collega con Radar”, o digita questo codice:',
  'aideR.q.employeur': 'Un datore di lavoro non è nell’elenco',
  'aideR.r.employeur': 'Aggiungi l’indirizzo della sua pagina di lavora con noi in Datori di lavoro. Se Radar non sa ancora leggerla, richiedi l’attivazione. Non è un guasto.',
  'aideR.cta.employeur': 'Vai ai datori di lavoro',
  'aideR.q.mails': 'Non ricevo le e-mail',
  'aideR.r.mails': 'Guarda prima nella posta indesiderata. Un indirizzo aziendale a volte filtra Radar: prova un indirizzo personale.',
  'aideR.cta.adresse': 'Cambia indirizzo',
  'aideR.q.rythme': 'Troppe e-mail, o troppo poche',
  'aideR.r.rythme': 'Cambia ritmo. Ognuno dice quante offerte ti avrebbe inviato.',
  'aideR.cta.rythme': 'Cambia ritmo',
  'aideR.q.pause': 'Vado in vacanza',
  'aideR.r.pause': 'Metti in pausa le e-mail per una, due o quattro settimane. Riprendono da sole.',
  'aideR.cta.pause': 'Metti in pausa',
  'aideR.q.supprimer': 'Eliminare il mio account',
  'aideR.r.supprimer': 'In fondo alle Impostazioni. Il tuo CV e i tuoi punteggi vengono cancellati. Puoi prima scaricare i tuoi dati.',
  'aideR.cta.compte': 'Apri il mio account',
  'aideR.prive.titre': 'Cosa resta privato',
  'aideR.prive.texte': 'Il tuo CV, i tuoi punteggi e le tue candidature sono visibili solo a te. I datori di lavoro seguiti e le loro offerte sono comuni a tutti gli account.',
  'aideR.ecrire.titre': 'Scrivici',
  'aideR.ecrire.texte': 'Un bug, un’idea, un sito da aggiungere: il messaggio arriva per e-mail, con il tuo indirizzo per la risposta.',
  'manques.titre': 'Cosa chiedono le tue offerte e il tuo CV non dice',
  'manques.intro': 'Sulle {n} offerte delle tue professioni negli ultimi 30 giorni. Se ce l’hai, scrivilo: i tuoi prossimi punteggi ne terranno conto.',
  'manques.chez': 'richiesto da {liste}',
  'manques.sitesAnnonces': 'siti di annunci',
  'manques.jeLai': 'Ce l’ho',
  'manques.ajoute': '“{mot}” aggiunto al tuo CV, nelle competenze.',
  'manques.annuler': 'Annulla',
  'manques.retire': '“{mot}” tolto dal tuo CV.',
  'manques.nAria': 'Richiesto da {n} offerte',
  'adresse.actuelle': 'Radar ti scrive a {email}.',
  'adresse.changer': 'Usa un altro indirizzo',
  'adresse.placeholder': 'Il tuo indirizzo personale',
  'adresse.envoyer': 'Invia il link di conferma',
  'adresse.aide': 'Un indirizzo di lavoro? I tuoi avvisi di lavoro verrebbero letti sul server del tuo datore di lavoro. Un altro indirizzo si conferma con un link.',
  'adresse.attente': 'In attesa di conferma: {attente}.',
  'adresse.statut.lienLe': 'Link inviato: {quand}.',
  'adresse.statut.envoye': 'Brevo l’ha preso in carico, ancora nessuna notizia dal server di destinazione.',
  'adresse.statut.livre': 'Accettato dal server di questo indirizzo.',
  'adresse.statut.differe': 'Ritardato dal server di questo indirizzo, nuovo tentativo in corso.',
  'adresse.statut.refuse': 'Rifiutato dal server di questo indirizzo: {raison}',
  'adresse.statut.pasParti': 'Il link non è partito: {erreur}',
  'adresse.statut.pasRecu': 'Non ricevuto? Guarda nella posta indesiderata o nella quarantena della tua casella.',
  'adresse.renvoyer': 'Invia di nuovo il link',
  'adresse.lienToast': 'Link inviato a {email}. Radar ti scriverà lì appena sarà aperto.',
  'adresse.compteToast': 'Radar ti scrive di nuovo all’indirizzo del tuo account.',
  'adresse.echecToast': 'Il link non è potuto partire. Riprova più tardi.',
  'adresse.confirmee': 'Indirizzo confermato: d’ora in poi Radar ti scriverà lì.',
  'adresse.lienInvalide': 'Questo link di conferma non è più valido. Chiedine uno nuovo.',
  'parcours.aria': 'La tua candidatura, passo dopo passo',
  'parcours.cv': 'Il tuo CV per {employeur}',
  'parcours.cvSans': 'Il tuo CV adattato',
  'parcours.cvPret': 'Pronto. Vedi e modifica qui sotto.',
  'parcours.cvPretEstime': 'Pronto. Punteggio stimato con questo CV: {estime} invece di {score}.',
  'parcours.lettre': 'La tua lettera (facoltativa)',
  'parcours.lettreRediger': 'Scrivi la lettera',
  'parcours.lettreNon': 'Non mi serve',
  'parcours.postuler': 'Candidati presso {employeur}',
  'parcours.postulerSans': 'Candidati dall’annuncio',
  'parcours.ouvrirPage': 'Apri la pagina di candidatura',
  'parcours.dejaFait': 'Fatto',
  'parcours.envoye': 'Inviata?',
  'parcours.envoyeOui': 'Sì, è inviata',
  'parcours.envoyeNon': 'Non la invierò',
  'parcours.envoyeToast': 'Annotato: inviata.',
  'parcours.envoyeNonToast': 'Annotato: esce dalle tue offerte.',
  'parcours.envoyeLe': 'Inviata il {date}. Senza notizie entro il {relance}, Radar ti proporrà un sollecito.',
  'suivi.lienPlaceholder': 'Incolla il link di un annuncio',
  'suivi.lienAria': 'Link di un annuncio',
  'suivi.lienAjouter': 'Aggiungi',
  'suivi.lienLecture': 'Lettura della pagina…',
  'suivi.lienIllisible': '{raison} Incolla il suo testo qui sotto.',
  'offre.lienLater': 'Hai scelto “Più tardi” nell’e-mail: conferma con un clic.',
  'offre.lienSkip': 'Hai scelto “Non fa per me” nell’e-mail: conferma con un clic.',
  'raison.loin': 'Troppo lontano',
  'raison.metier': 'Non è la mia professione',
  'raison.salaire': 'Stipendio',
  'raison.employeur': 'Non questo datore di lavoro',
  'raison.autre': 'Altro',
  'raison.merci': 'Grazie, ne abbiamo preso nota.',
  'suivi.rappelLe': 'promemoria lunedì {date}',
  'emp.pourVousUn': '1 offerta per te su {n} nelle tue professioni, la migliore a {m}.',
  'emp.pourVousPlus': '{k} offerte per te su {n} nelle tue professioni, la migliore a {m}.',
  'emp.uneSeule': '1 offerta nelle tue professioni, a {m}: supera la tua soglia.',
  'emp.sousSeuil': '{n} offerte nelle tue professioni, nessuna a {seuil} o più. La migliore: {m}.',
  'emp.sousSeuilUn': '1 offerta nelle tue professioni, a {m}: sotto la tua soglia di {seuil}.',
  'emp.prefixeAnnonces': 'Sito di annunci · {phrase}',
  'emp.retour': 'Datori di lavoro',
  'emp.introuvable': 'Questo datore di lavoro non è più seguito da Radar.',
  'emp.suiviDepuis': 'seguito dal {date}',
  'emp.dansMetiersTitre': 'Nelle tue professioni',
  'emp.etatCandidature': 'Nelle tue candidature',
  'emp.autresUn': '1 altra offerta presso {nom}',
  'emp.autresPlus': '{n} altre offerte presso {nom}',
  'emp.chercher': 'Cerca in queste offerte',
  'emp.evaluer': 'Valuta per me',
  'emp.aucunResultat': 'Nessuna offerta corrisponde.',
  'emp.autresAide': 'Fuori dalle tue professioni Radar non dà punteggi: le elenca perché niente ti sfugga. “Valuta per me” confronta un’offerta precisa con il tuo CV.',
  'emp.vide': 'Per ora nessuna offerta online presso questo datore di lavoro.',
  'emp.illisibleNuits': 'Illeggibile da {n} notti. Il team è avvisato, non devi fare nulla.',
  'emp.illisibleNuit': 'Illeggibile stanotte. Il team è avvisato, non devi fare nulla.',
  'emp.apprentissage': 'In apprendimento: risposta entro il {date}. Non conta nei tuoi {max}.',
  'emp.apprentissageDepuis': 'In apprendimento dal {date}. Non conta nei tuoi {max}.',
  'emp.apprendLire': 'Radar sta imparando a leggere {hote}. Risposta entro il {date}.',
  'emp.apprendLireDepuis': 'Radar sta imparando a leggere {hote} dal {date}.',
  'emp.refusee': 'Radar non sa leggere {hote}.',
  'emp.rangeesIci': 'Nel frattempo le tue offerte di {nom} tenute dall’estensione si raccolgono qui.',
  'emp.rangeesIciRefus': 'Le tue offerte di {nom} tenute dall’estensione restano raccolte qui.',
  'emp.suivisTitre': 'Seguiti',
  'emp.enAttenteTitre': 'In apprendimento · non contano nei tuoi {max}',
  'emp.enAttenteTitreSansMax': 'In apprendimento',
  'emp.annoncesTitre': 'Siti di annunci',
  'emp.annoncesAide': 'Centinaia di datori di lavoro: Radar ne tiene solo le tue professioni e le tue regioni.',
  'emp.suggeresTitre': 'Suggeriti per te',
  'emp.suggereUn': '1 offerta nelle tue professioni',
  'emp.suggerePlus': '{n} offerte nelle tue professioni',
  'emp.luQuand': 'Letto {quand}',
  'emp.sousTitre': 'Radar rilegge le loro pagine ogni notte · {n} siti seguiti su {max}',
  'emp.sousTitreSansMax': 'Radar rilegge le loro pagine ogni notte · {n} siti seguiti',
  'pont.texte': 'Hai tenuto {n} offerte di {nom} dall’estensione. Mettere {nom} sul tuo radar?',
  'pont.suivre': 'Segui {nom}',
  'pont.ajouter': 'Aggiungi la sua pagina di lavora con noi',
  'pont.non': 'No, grazie',
  'pont.nonToast': 'Radar non te lo proporrà più.',
  'entretien.titre': 'Prepara il colloquio',
  'entretien.aide': 'Le domande probabili, e ciò che il tuo CV ti permette di rispondere.',
  'entretien.preparer': 'Prepara',
  'entretien.redaction': 'Preparazione…',
  'entretien.refaire': 'Rifai',
  'entretien.aPoser': 'Da chiedere a loro',
  'entretien.aideSourcee': 'Radar cerca le notizie del datore di lavoro e il suo modo di selezionare, poi prepara le domande probabili. Ogni fonte è citata. Circa un minuto.',
  'entretien.enCours': 'Radar sta cercando, circa un minuto. Puoi lasciare la pagina.',
  'entretien.erreur': 'La ricerca non è andata a buon fine.',
  'entretien.actualite': 'Il datore di lavoro in questo momento',
  'entretien.deroule': 'Come seleziona',
  'entretien.questions': 'Le domande probabili',
  'entretien.tireeOffre': 'Tratta dall’offerta:',
  'entretien.rapportee': 'Riferita',
  'entretien.rienTrouve': 'Niente di pubblico e recente trovato sul datore di lavoro.',
  'entretien.agence': 'L’offerta non nomina il datore di lavoro. Se lo conosci, Radar cercherà su di lui.',
  'entretien.employeurNom': 'Nome del datore di lavoro',
  'entretien.avecEmployeur': 'Cerca su questo datore di lavoro',
  'entretien.parcours': 'Candidatura inviata · Rivedi il percorso',
  'remu.titre': 'Retribuzione',
  'remu.encore': 'Ancora {n} questo mese.',
  'remu.plusDEssai': 'Nessun tentativo rimasto questo mese.',
  'remu.aVolonte': 'A volontà con Complet.',
  'remu.avecComplet': 'Con Radar Complet.',
  'remu.comparer': 'Confronta',
  'remu.nonAnnonce': 'Stipendio non indicato',
  'remu.estimer': 'Stima',
  'remu.aide': 'Radar cerca ciò che l’offerta indica, il minimo di settore e riferimenti recenti, e cita ogni fonte. Circa un minuto.',
  'remu.lancer': 'Stima lo stipendio',
  'remu.enCours': 'Radar sta cercando, circa un minuto. Puoi lasciare la pagina.',
  'remu.erreur': 'La ricerca non è andata a buon fine.',
  'remu.reessayer': 'Riprova',
  'remu.offreDit': 'Cosa dice l’offerta',
  'remu.offreMuette': 'L’offerta non indica un importo.',
  'remu.minimum': 'Il minimo di settore',
  'remu.auMoins': '{qui}: almeno {montant}',
  'remu.sousEnPartie': 'La parte bassa della forbice indicata è sotto questo minimo.',
  'remu.sousEntierement': 'L’importo indicato è sotto questo minimo.',
  'remu.marche': 'I riferimenti di mercato',
  'remu.fourchette': '{fourchette}, secondo {n} fonti concordanti.',
  'remu.pasDeFourchette': 'I riferimenti non concordano abbastanza per una forbice.',
  'remu.aucunRepere': 'Nessun riferimento affidabile trovato.',
  'remu.unRepere': 'Un solo riferimento affidabile, nessuna forbice.',
  'remu.quatreCinquiemes': 'Al 4/5: {fourchette}',
  'remu.avantages': 'I benefit',
  'remu.aDemander': 'Da chiedere',
  'remu.agence': 'L’offerta non nomina il datore di lavoro: i riferimenti valgono per la professione.',
  'remu.source': 'Fonte: {qui}',
  'remu.sourceDatee': 'Fonte: {qui}, {date}',
  'remu.sourceOffre': 'l’offerta',
  'remu.sources': 'Fonti: {retenues}, {ecartees}',
  'remu.retenue1': '1 tenuta',
  'remu.retenues': '{n} tenute',
  'remu.ecartee1': '1 scartata',
  'remu.ecarteesN': '{n} scartate',
  'remu.ecartees': 'Scartate',
  'remu.estimeLe': 'Stimato il {date}.',
  'remu.refaire': 'Rifai',
  'remu.environ': 'Circa {montant}',
  'remu.entre': 'da {a} a {b}',
  'remu.parHeure': 'lordi all’ora',
  'remu.parMois': 'lordi al mese',
  'remu.parAn': 'lordi all’anno',
  'remu.raison.page_fermee': 'pagina chiusa o rimossa',
  'remu.raison.page_illisible': 'pagina illeggibile',
  'remu.raison.introuvable': 'citazione non trovata nella pagina',
  'remu.raison.trop_ancienne': 'più di 18 mesi',
  'remu.raison.domaine_ecarte': 'aggregatore o copia',
  'remu.raison.sans_extrait': 'senza citazione',
  'remu.raison.sans_source': 'senza indirizzo',
  'remu.raison.chiffre_absent': 'cifra assente dalla citazione',
  'remu.raison.autre_pays': 'altro paese o altra valuta',
  'remu.cadre': 'Paese del ruolo: {pays}. Importi lordi annui.',
  'remu.fiabiliteTitre': 'Il datore di lavoro',
  'remu.fiabilite': '{type}. Affidabilità delle cifre pubbliche: {fiab}.',
  'remu.soit': '(cioè {montant})',
  'remu.comp.base': 'Base',
  'remu.comp.variable': 'Variabile',
  'remu.comp.avantage': 'Benefit',
  'remu.fiab.haute': 'alta',
  'remu.fiab.moyenne': 'media',
  'remu.fiab.basse': 'bassa',
  'remu.fiab.inconnue': 'sconosciuta',
  'remu.type.grand_groupe_tech': 'Grande gruppo tecnologico',
  'remu.type.startup_croissance': 'Start-up in crescita',
  'remu.type.startup_debut': 'Start-up giovane',
  'remu.type.entreprise_traditionnelle': 'Azienda consolidata',
  'remu.type.conseil_ou_agence': 'Consulenza o agenzia',
  'remu.type.pme_locale': 'PMI locale',
  'remu.type.commission': 'Retribuzione a provvigione',
  'remu.type.recrutement_tiers': 'Offerta pubblicata da un selezionatore',
  'remu.type.public': 'Settore pubblico o associativo',
  'remu.type.inconnu': 'Tipo di datore di lavoro sconosciuto',
  'relance.titre': 'Una settimana senza notizie?',
  'relance.aide': 'Inviata il {date}. Radar propone un solo sollecito per candidatura.',
  'relance.preparer': 'Prepara il mio sollecito',
  'relance.redaction': 'Scrittura…',
  'relance.objet': 'Oggetto: {sujet}',
  'relance.copier': 'Copia',
  'relance.copie': 'Sollecito copiato.',
  'relance.envoyee': 'L’ho inviato',
  'relance.reecrire': 'Riscrivi',
  'relance.reponse': 'Ho ricevuto una risposta',
  'relance.reponseQuestion': 'Quale risposta?',
  'relance.entretien': 'Un colloquio',
  'relance.refus': 'Un rifiuto',
  'relance.abandon': 'Lascio perdere',
  'relance.abandonQuestion': 'Lasciar perdere questa candidatura? Esce da Le mie offerte.',
  'relance.abandonOui': 'Sì, lascia perdere',
  'relance.abandonToast': 'Candidatura tolta da Le mie offerte.',
}
